import * as React from 'react';
import {
  useGlobalSettings,
  withGlobalSettingsProvider,
} from '@narvar/nth-hook-global-settings';
import { SmsCountry } from '@narvar/nth-hook-loma';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';
import flags from '../../lib/flags';

interface CountrySelectorProps {
  selectedCountryCode?: SmsCountry;
  minHeight?: string | number;
  onSelectCallback?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CountrySelector: React.FunctionComponent<CountrySelectorProps> = ({
  selectedCountryCode,
  minHeight,
  onSelectCallback,
}) => {
  const { smsSupportedCountries } = useGlobalSettings();

  const { countryDropdownAriaLabel } = useTranslations();

  let selectedCountryIndex = -1;

  const countries = flags.reduce(
    (fin: JSX.Element[], { code, emoji, name }, index: number) => {
      const option = (
        <option key={`${code} ${emoji}`} value={index}>
          {name}
        </option>
      );

      if (selectedCountryCode === code) {
        selectedCountryIndex = index;
      }

      if (smsSupportedCountries && smsSupportedCountries.length > 0) {
        if (smsSupportedCountries.includes(code)) {
          fin.push(option);
        }
      } else {
        fin.push(option);
      }

      return fin;
    },
    [],
  );

  return (
    <select
      value={selectedCountryIndex}
      aria-label={countryDropdownAriaLabel || ''}
      onChange={onSelectCallback}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        minHeight,
        opacity: 0,
      }}
    >
      {countries}
    </select>
  );
};

export default withGlobalSettingsProvider(
  withTranslationsProvider(CountrySelector, {
    translationKeys: ['countryDropdownAriaLabel'],
  }),
  { globalSettingsRequested: 'smsSupportedCountries' },
);
